import { PAGE_BUILDER_CODE_COMPONENT, PageBuilderItem } from '../page-builder-components.models';
import { DynamicInputModelConfig, DynamicInputModel, serializable, DynamicFormControlLayout } from '@ng-dynamic-forms/core';

export interface PageBuilderFilePickerModelConfig extends DynamicInputModelConfig {
}

export class PageBuilderFilePickerModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_file_picker'; 

	constructor(config: PageBuilderFilePickerModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
	}

	static initModel(_component: PageBuilderItem): PageBuilderFilePickerModel { 
		const formModel = new PageBuilderFilePickerModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE
		});
		return formModel;
	}

    static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.FILE_PICKER,
            NAME: 'Fichier',
            ICON: 'attach_file',
            PROPERTIES: [
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                { ID: 'DEFAULT_VALUE', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Valeur' },
            ]
        };
    }
} 